var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Head'),_c('router-view'),_c('Contact'),_c('Foot'),_c('div',{attrs:{"id":"toTop"},on:{"click":_vm.top}},[_c('span',{staticClass:"glyphicon glyphicon-arrow-up",attrs:{"aria-hidden":"true"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }